import baseAPI from '@/api/base';
import { EditMinyan_N, GetMinyan_N, RegisterMinyan_N } from '@/dtos/minyan_N.dto';
import {
  DELETE_MINYAN_N_URL,
  EDIT_MINYAN_N_URL,
  GET_MINYAN_N_URL,
  REGISTER_MINYAN_N_URL,
  TOGGLE_MINYAN_N_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Minyan_N {
  static getMinyans_N = async (
    getMinyan_N: GetMinyan_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MINYAN_N_URL, {
      params: getMinyan_N,
    });
    console.log('response', response);
    return response;
  };

  static registerMinyan_N = async (
    registerMinyan_N: RegisterMinyan_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_MINYAN_N_URL,
      {
        ...registerMinyan_N,
      }
    );
    console.log('response', response);
    return response;
  };

  static editMinyan_N = async (
    editMinyan_N: EditMinyan_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_MINYAN_N_URL,
      {
        ...editMinyan_N,
      }
    );
    return response;
  };

  static toggleMinyan_NIsActive = async (
    editMinyan_N: EditMinyan_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_MINYAN_N_IS_ACTIVE_URL,
      {
        ...editMinyan_N,
      }
    );
    return response;
  };

  static deleteMinyan_N = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_MINYAN_N_URL}/${id}`
    );
    return response;
  };
}

export default Minyan_N;

